var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-panel"},[_c('div',{staticClass:"pull-left"},[_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-2x fa-user-o"})])]),_vm._v(" "),_c('div',{staticClass:"pull-left info"},[_c('p',[_vm._v("Trilok Prithvi")])])])
}]

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/side-bar/User.vue